export default "__VITE_ASSET__90178974__"